<template>
  <v-container class="login-container d-flex align-center justify-center fill-height">
    <v-card class="pa-5 login-card">
      <div class="d-flex justify-space-between align-center">
        <v-img
            alt="Hitachi Logo"
            class="ma-5"
            contain
            max-width="50%"
            src="/hitachi-logo.png"
        />
        <v-img
            alt="NAT Logo"
            class="ma-5"
            contain
            max-width="50%"
            src="/NAT_logo.png"
        />
      </div>
      <v-card-text>
        <v-form ref="form" @submit.prevent="login">

          <v-select
              v-model="selectedProfile"
              :items="authStore.operatorProfiles"
              :loading="authStore.loading"
              label="Select Profile"
              variant="outlined"
          ></v-select>

          <v-btn
              :disabled="!selectedProfile || useICPStore().eventData.status !== '0'"
              block
              class="mt-3"
              color="#4c4c4c" type="submit">
            Login
          </v-btn>
          <v-btn
              block
              class="mt-3"
              color="#4c4c4c" type="button"
              @click="keycloak.logout();">
            Back
          </v-btn>

          <!-- Status indicator -->
          <div class="d-flex flex-column align-center justify-center mt-4">
            <div v-if="!useICPStore().eventData" class="d-flex align-center">
              <v-progress-circular
                  class="mr-2"
                  color="grey"
                  indeterminate
                  size="20"
                  width="2"
              ></v-progress-circular>
              <span>Initializing SDK...</span>
            </div>

            <div v-else-if="useICPStore().eventData.status === '0'" class="d-flex align-center">
              <v-icon class="mr-2" color="green">
                mdi-check-circle
              </v-icon>
              <span class="text-success">SDK ready</span>
            </div>

            <div v-else class="d-flex align-center">
              <v-icon class="mr-2" color="red">
                mdi-close-circle
              </v-icon>
              <span class="text-error">{{ useICPStore().eventData.desc }}</span>
            </div>
          </div>


        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>

import {onMounted, ref} from 'vue';
import {useAuthStore} from '@/stores/authStores';
import {useICPStore} from "@/stores/icpStore";
import {keycloak} from "@/main";

const authStore = useAuthStore();

const selectedProfile = ref(null);

onMounted(() => {
      setTimeout(async () => {
        authStore.fetchProfiles()
      }, 1000);
    }
)

const login = () => {
  authStore.fetchCredentials(selectedProfile);
};

</script>


<style scoped>

.login-container {
  height: 100% !important;
  background-color: #f5f5f5;
  max-width: 100% !important;
}

.login-card {
  width: 33vw !important;
  height: 90vh !important;
  overflow-y: auto;
}
</style>